
// const API_BASE_URL = 'https://admin.complyco.com.au/'
// const Shopper_API_BASE_URL = 'https://shopper.complyco.com.au/'
// const MMCOMMON_API_BASE_URL = 'https://www.complyco.com.au/'
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL


export const usersLogin = `${API_BASE_URL}/auth/login`
export const forgotPassowrd = `${API_BASE_URL}/auth/forgot-password`
export const verifyOtp = `${API_BASE_URL}/auth/verify-otp`
export const resetPassword = `${API_BASE_URL}/auth/reset-password`

export const getAdminDshboard = `${API_BASE_URL}/admin/get-admin-dashboard`

export const createCategory = `${API_BASE_URL}/category/create-category`
export const getCategories = `${API_BASE_URL}/category/get-categories`


export const fileUpload = `${API_BASE_URL}/upload/upload-file`


export const createColor = `${API_BASE_URL}/color/create-color`
export const getColor = `${API_BASE_URL}/color/get-colors`


export const createSize = `${API_BASE_URL}/size/create-size`
export const getSize = `${API_BASE_URL}/size/get-sizes`



export const updateProduct = `${API_BASE_URL}/product/update-product`
export const getProducts = `${API_BASE_URL}/product/get-products`
export const getProductbyId = `${API_BASE_URL}/product/get-product-by-id`
export const updateProductStatus = `${API_BASE_URL}/product/update-product-status`
export const createProduct = `${API_BASE_URL}/product/create-product`
export const createVariant = `${API_BASE_URL}/variant/create-variant`


export const getClientList = `${API_BASE_URL}/clients/get-clients`
export const getClientDashboard = `${API_BASE_URL}/clients/get-client-dashboard`
export const createclient = `${API_BASE_URL}/clients/create-client`
export const updateclient = `${API_BASE_URL}/clients/update-client`
export const deletclient = `${API_BASE_URL}/clients/delete-client`




export const getDealerList = `${API_BASE_URL}/subClients/get-sub-clients`
export const createDealer = `${API_BASE_URL}/subClients/create-sub-client`
export const updateDealer = `${API_BASE_URL}/subClients/update-sub-clients`
export const deleteDealer = `${API_BASE_URL}/subClients/delete-sub-clients`


export const connecttoRazorPay = `${API_BASE_URL}/payment/connect`
export const autorizeRazorpay = `${API_BASE_URL}/payment/oauth`

export const createOrder = `${API_BASE_URL}/order/create-order`
export const getOrders = `${API_BASE_URL}/order/get-orders`
export const getOrderId = `${API_BASE_URL}/order/get-order-by-id`
export const updateOrderStatus = `${API_BASE_URL}/order/update-order-status`


export const getCartList = `${API_BASE_URL}/cart/get-cart`
export const addtoCart = `${API_BASE_URL}/cart/add-to-cart`
export const updateCart = `${API_BASE_URL}/cart/update-cart-item`
export const deleteCartItem = `${API_BASE_URL}/cart/delete-cart`


export const getAddress = `${API_BASE_URL}/address/get-address`
export const createAddress = `${API_BASE_URL}/address/create-address`
export const updateAddress = `${API_BASE_URL}/address/update-address`
export const deleteAddress = `${API_BASE_URL}/address/delete-address`


export const getInvoices = `${API_BASE_URL}/invoice/get-invoices`


export const getDealerDashboard = `${API_BASE_URL}/subClients/get-dealer-dashboard`


export const createPayment = `${API_BASE_URL}/payment/create-payment`